module.exports = __webpack_public_path__ + "static/img/38.462c0bee.png";